
import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import MobileStickyBar from './components/feature/MobileStickyBar';
import GetQuoteModal from './components/feature/GetQuoteModal';

function App() {
  const [showQuoteModal, setShowQuoteModal] = useState(false);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="min-h-screen flex flex-col overflow-x-hidden w-full">
          <Header onGetQuote={() => setShowQuoteModal(true)} />
          <main className="flex-grow overflow-x-hidden w-full">
            <AppRoutes />
          </main>
          <Footer />
          <MobileStickyBar onGetQuote={() => setShowQuoteModal(true)} />
          
          {showQuoteModal && (
            <GetQuoteModal onClose={() => setShowQuoteModal(false)} />
          )}
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
